module.exports = __webpack_public_path__ + "static/media/camping-vw-van.09b6267b.png";